import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './en';
import { jp } from './jp';
import { vi } from './vi';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translations: en,
    },
    jp: {
      translations: jp,
    },
    vi: {
      translations: vi,
    },
  },
  fallbackLng: 'en',
  debug: false,
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
  react: {
    wait: true,
  },
  lng: 'en',
  keySeparator: '.',
});
export default i18n;
